import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './business-funding-page.css'

const BusinessFundingPage = (props) => {
  return (
    <div className="business-funding-page-container10">
      <Helmet>
        <title>Business Funding - Help Me Out</title>
        <meta property="og:title" content="Business Funding - Help Me Out" />
        <link rel="canonical" href="https://www.helpmeout.co.za/business-funding-page" />
        <meta property="og:url" content="https://www.helpmeout.co.za/business-funding-page" />
      </Helmet>

      {/* ── Hero ── */}
      <div className="business-funding-page-thq-container-elm">
        <div className="business-funding-page-container11">
          <div className="business-funding-page-container12">
            <img alt="Help Me Out Logo" src="/hmol%20logo-1500w.png" className="business-funding-page-image" />
          </div>
          <div className="business-funding-page-container13">
            <span className="business-funding-page-eyebrow">Business Capital</span>
            <h1 className="business-funding-page-thq-heading-elm">
              Help Me Out Business Capital Support
            </h1>
            <h2 className="business-funding-page-thq-sub-heading-elm">
              We provide reliable business funding solutions to help your company grow.
            </h2>
          </div>
          <div className="business-funding-page-container14">
            <a
              href="https://apply.getfunds.co.za/?broker=marchell_erasmus"
              target="_blank"
              rel="noreferrer noopener"
              className="business-funding-page-link"
            >
              <div className="business-funding-page-container15">
                <span className="business-funding-page-text10">Apply Now</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      <Navbar />

      {/* ── Ideal Uses ── */}
      <div className="business-funding-page-thq-layout349-elm thq-section-padding">
        <div className="business-funding-page-thq-max-width-elm1 thq-section-max-width">
          <div className="business-funding-page-container22">
            <h2 className="business-funding-page-text14">Ideal Uses For Our Funding</h2>
            <a
              href="https://apply.getfunds.co.za/?broker=marchell_erasmus"
              target="_blank"
              rel="noreferrer noopener"
              className="business-funding-page-thq-button-elm1"
            >
              Apply Now
            </a>
          </div>
          <div className="thq-grid-3">
            {[
              { title: 'Equipment & Asset Upgrades',        desc: 'Repair, replace, or purchase essential machinery, delivery vehicles, and power solutions.' },
              { title: 'Technology & Infrastructure',       desc: 'Fund IT upgrades, install security systems, and improve business operations.' },
              { title: 'Foreign Trade & Supply Chain',      desc: 'Offset forex fluctuations, bypass middlemen, and mitigate import delays.' },
              { title: 'Large-Scale Financial Assistance',  desc: 'Assist with high-cost investment deposits such as land, buildings, and business expansion.' },
              { title: 'Inventory & Stock Management',      desc: 'Buy in bulk for discounts, secure stock before peak seasons, and prevent lost sales.' },
              { title: 'Business Growth & Expansion',       desc: 'Open new locations, launch new products, and fund business upgrades or buyouts.' },
            ].map((item, i) => (
              <div key={i} className={`business-funding-page-container${24 + i} thq-card`}>
                <h2 className="thq-heading-2">{item.title}</h2>
                <span className={`business-funding-page-text${16 + i * 2} thq-body-small`}>{item.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Why Choose Us ── */}
      <div className="business-funding-page-container30">
        <div className="business-funding-page-container31">
          <h2 className="business-funding-page-text29">Why Choose Us</h2>
        </div>
        <div className="business-funding-page-container32">
          <h3>More Options, More Flexibility</h3>
          <span>Instant access to multiple funders with one 2-minute application.</span>
        </div>
        <div className="business-funding-page-container33">
          <h3>Higher Approval Rates</h3>
          <span>We shop multiple funders giving us the highest approval rate in South Africa.</span>
        </div>
      </div>

      {/* ── Funding Options ── */}
      <div className="business-funding-page-thq-faq9-elm thq-section-padding">
        <div className="business-funding-page-thq-max-width-elm3 thq-section-max-width thq-flex-column">
          <div className="thq-flex-column" style={{ alignItems: 'flex-start', width: '100%' }}>
            <h2 className="business-funding-page-thq-text-elm">Funding Options</h2>
          </div>
          <div className="thq-flex-column" style={{ width: '100%' }}>

            <div className="business-funding-page-thq-row-elm1">
              <div className="thq-divider-horizontal"></div>
              <div className="business-funding-page-thq-content-elm3">
                <p className="business-funding-page-thq-faq1-question-elm thq-body-large">Merchant Cash Advance</p>
                <span className="business-funding-page-thq-faq1-answer-elm thq-body-small">
                  Receive up to one month's revenue as a cash advance. Pay over 3–12 months at 2%–3.8% per month depending on your risk profile. Daily, weekly & monthly repayments available. We can stack on top of existing facilities and consolidate high-cost financing into a tailored solution.
                </span>
              </div>
            </div>

            <div className="business-funding-page-thq-row-elm2">
              <div className="thq-divider-horizontal"></div>
              <div className="business-funding-page-thq-content-elm4">
                <p className="business-funding-page-thq-faq2-question-elm thq-body-large">Invoice Backed Funding</p>
                <span className="business-funding-page-thq-faq2-answer-elm thq-body-small">
                  Access a line of credit secured by your invoices. Convert 30–90 day term invoices into instant cash flow. Confidential — your customers remain uninvolved. Competitive discount rates of 2%–3% per month.
                </span>
              </div>
            </div>

            <div className="business-funding-page-thq-row-elm3">
              <div className="thq-divider-horizontal"></div>
              <div className="business-funding-page-thq-content-elm5">
                <p className="business-funding-page-thq-faq4-question-elm thq-body-large">Medical Funding</p>
                <span className="business-funding-page-thq-faq4-answer-elm thq-body-small">
                  Get a cash advance and repay as you practice. Repayments align directly with your medical aid claims via debit order. Your Medical Practice Advance is repaid as a percentage of future medical aid claims.
                </span>
              </div>
            </div>
          </div>

          <div className="business-funding-page-thq-content-elm6 thq-flex-column">
            <a
              href="https://apply.getfunds.co.za/?broker=marchell_erasmus"
              target="_blank"
              rel="noreferrer noopener"
              className="business-funding-page-thq-button-elm2"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>

      <Footer
        text={<Fragment><span className="business-funding-page-text98">Authorized Financial Credit Provider</span></Fragment>}
        text1={<Fragment><span className="business-funding-page-text99">Our Partner In Business Funding</span></Fragment>}
        content1={<Fragment><span className="business-funding-page-text100">Apply now for instant financial assistance.</span></Fragment>}
        content2={<Fragment><span className="business-funding-page-text101">Get financial support when you need it most with HelpMeOut.</span></Fragment>}
        copyright={<Fragment><span className="business-funding-page-text102">© {new Date().getFullYear()} HelpMeOut. All rights reserved.</span></Fragment>}
        termsLink={<Fragment><span className="business-funding-page-text103">Terms of Use</span></Fragment>}
        cookiesLink={<Fragment><span className="business-funding-page-text104">Cookies</span></Fragment>}
        privacyLink={<Fragment><span className="business-funding-page-text105">Privacy Policy</span></Fragment>}
      />
    </div>
  )
}

export default BusinessFundingPage
